import { localizedStringWithDefault } from '@pressreader/resources';

const signInStatusMessages = {
    1: () => localizedStringWithDefault('Dialogs.Signin.InvalidLoginOrPass', 'Invalid user name or password.'),
    2: () =>
        localizedStringWithDefault('Dialogs.Signin.MaxAllowedSimultaneousSessionsExceeded', 'You have exceeded the number of simultaneous sessions.'),
    5: () => localizedStringWithDefault('Dialogs.Signin.Invactive', 'Your account is not active.'),
};

const enum ExtAuthStatuses {
    Success,
    InvalidUserNameOrPassword,
    SubscriptionRequired,
    Found,
    Error,
}

const ExtAuthStatusesToString = {
    [ExtAuthStatuses.Success]: 'Success',
    [ExtAuthStatuses.InvalidUserNameOrPassword]: 'InvalidUserNameOrPassword',
    [ExtAuthStatuses.SubscriptionRequired]: 'SubscriptionRequired',
    [ExtAuthStatuses.Found]: 'Found',
    [ExtAuthStatuses.Error]: 'Error',
};

const authorizeExtAuthStatusMessages = {
    InvalidUserNameOrPassword: () => localizedStringWithDefault('Errors.SignInFailed2', 'Invalid user name or password.'),
    SubscriptionRequired: () => localizedStringWithDefault('Errors.SubscriptionRequired', 'Subscription Required.'),
    Found: () => localizedStringWithDefault('Errors.UserFound', 'User Found.'),
    Error: () => localizedStringWithDefault('Errors.SignInFailed2', 'SignIn Failed.'),
    InvalidToken: () => localizedStringWithDefault('Errors.AccessTokenExpired', 'Invalid Access Token'),
    UserAlreadyExists: () => localizedStringWithDefault('Errors.UserAlreadyExists', 'User Already Exists'),
};

// Map backend enum results to front functions that return messages
const VerifyAccountStatusMessages = {
    InvalidUserName: signInStatusMessages[1],
    InvalidPassword: signInStatusMessages[1],
    UnknownError: () => localizedStringWithDefault('Errors.ErrorOccurred', 'Error Occurred'),
    Found: authorizeExtAuthStatusMessages.Found,
    SubscriptionRequired: authorizeExtAuthStatusMessages.SubscriptionRequired,
    Unknown: () => localizedStringWithDefault('Errors.ErrorOccurred', 'Error Occurred'),
    InvalidToken: authorizeExtAuthStatusMessages.InvalidToken,
    UserAlreadyExists: authorizeExtAuthStatusMessages.UserAlreadyExists,
};

const AuthenticationResultMessages = {
    InvalidUserName: signInStatusMessages[1],
    InvalidPassword: signInStatusMessages[1],
    ExceedMaxSimultaneousSessionsPerUser: signInStatusMessages[2],
    UnknownError: () => localizedStringWithDefault('Errors.ErrorOccurred', 'Error Occurred'),
    ExceedMaxIncorrectPasswordAttempts: () => localizedStringWithDefault('Errors.ErrorOccurred', 'Error Occurred'),
};

export {
    AuthenticationResultMessages,
    authorizeExtAuthStatusMessages,
    ExtAuthStatuses,
    ExtAuthStatusesToString,
    signInStatusMessages,
    VerifyAccountStatusMessages,
};
